export default __webpack_public_path__ + "static/media/1325.58cc0b09.png";